export const BOOK_APPOINTMENT = 'booking-amc360/BOOK_APPOINTMENT';
export const BOOK_APPOINTMENT_SUCCESS =
  'booking-amc360/BOOK_APPOINTMENT_SUCCESS';
export const BOOK_APPOINTMENT_ERROR = 'booking-amc360/BOOK_APPOINTMENT_ERROR';

export const UPDATE_BOOKING_INFO = 'booking-amc360-detail/UPDATE_BOOKING_INFO';
export const UPDATE_BOOKING_INFO_SUCCESS =
  'booking-amc360-detail/UPDATE_BOOKING_INFO_SUCCESS';
export const UPDATE_BOOKING_INFO_ERROR =
  'booking-amc360-detail/UPDATE_BOOKING_INFO_ERROR';
